/**
 * SearchField — поле поиска (иконка-лупа + input). Обёртка стилизуется
 * снаружи через `className` (высота/радиус/фон/бордер), внутренняя
 * разметка одинаковая — убирает повтор «иконка + input» по экранам.
 */

import {Search} from 'lucide-react';

import {cn} from '@lib/utils';

type SearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
};

export const SearchField = ({
  value,
  onChange,
  placeholder,
  className,
  autoFocus,
}: SearchFieldProps) => (
  <div className={cn('flex items-center gap-2.5', className)}>
    <Search className="size-[17px] shrink-0 text-muted-foreground" strokeWidth={1.9} />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
      className="h-full min-w-0 flex-1 border-none bg-transparent text-sm outline-none placeholder:text-muted-foreground"
    />
  </div>
);
